import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import { AuthenticateRequest } from 'src/api';
import { LoginStore } from 'src/login/stores/login.store';
import { lazyInject } from '../../ioc';
import { ResetConfirm } from './desktop/reset-confirm';

@observer
export class ResetConfirmContainer extends React.Component<RouteComponentProps<void>> {
    @lazyInject(LoginStore) loginStore!: LoginStore;

    @observable isBusy = false;

    email: string | undefined;
    private password: string | undefined;

    constructor(props: RouteComponentProps<void>) {
        super(props);

        if (!this.loginStore.pwFormEmail || !this.loginStore.pwFormPassword) {
            this.props.history.push('/login');
            return;
        }

        this.email = this.loginStore.pwFormEmail;
        this.password = this.loginStore.pwFormPassword;
    }

    componentDidMount() {
        renderReCaptcha(this.handleLogin);
    }

    render() {
        return <ResetConfirm container={this} />;
    }

    private withBusy<T>(promise: Promise<T>): Promise<T> {
        this.isBusy = true;
        const callback = () => (this.isBusy = false);
        promise.then(callback, callback);
        return promise;
    }

    handleSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        grecaptcha.execute();
    };

    /**
     * @param {string} token the response token get from reCAPTCHA after user submit the form, it's used to check if the user has been verified by Google
     */
    @action private handleLogin = (token: string) => {
        if (!this.email || !this.password) {
            return;
        }
        const req: AuthenticateRequest = {
            email: this.email,
            password: this.password,
            reCaptchaToken: token,
            stayLoggedIn: false,
        };
        this.withBusy(this.loginStore.authenticate(req)).then(
            () => this.props.history.push('/'),
            () => this.props.history.push('/login')
        );
    };
}
